import { FilterChipDateRange, FilterChipSelect, FiltersClearButton, FiltersProvider } from '@nexelem/filters';
import { GridComponentProps } from '@nexelem/table';
import { SimulationListFilterData, SimulationListStatusView } from '@nexelem/graphne-api';
import { useMemo } from 'react';
import { useStore } from 'zustand';
import { toggleSortColumnsDrawer } from '../../../../../molecules/SortColumnsDrawer';
import { toggleFiltersManagerDrawer } from '../../../../FiltersManagerDrawer';
import { FilterActionsDropdown } from '../../../../FilteredGridPage';
import { useCustomTranslation } from '../../../../../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarRange } from '@fortawesome/pro-light-svg-icons';

export const SimulationListFilters = ({
  onChange,
  filters,
  store,
  columns,
  defaultColumns,
}: GridComponentProps<SimulationListFilterData>) => {
  const count = useStore(store, (state) => state.settings.length);
  const onResetActiveFilter = useStore(store, (state) => state.setActiveId);
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const { tWrapper: tFilters } = useCustomTranslation('components.filters');

  const statusOptions = useMemo(
    () => [
      { key: tWrapper('simulationStatus.New'), value: SimulationListStatusView.New },
      { key: tWrapper('simulationStatus.InProgress'), value: SimulationListStatusView.InProgress },
      { key: tWrapper('simulationStatus.Complete'), value: SimulationListStatusView.Complete },
      { key: tWrapper('simulationStatus.Error'), value: SimulationListStatusView.Error },
    ],
    [tWrapper],
  );

  return (
    <FiltersProvider value={filters} onChange={onChange}>
      {(register) => (
        <>
          <FilterChipDateRange
            Icon={() => <FontAwesomeIcon icon={faCalendarRange} />}
            label={tWrapper('simulationListColumn.creationDate')}
            path="creationDate"
            register={register}
          />
          <FilterChipSelect
            isMultiple
            label={tWrapper('simulationListColumn.status')}
            options={statusOptions}
            path="status"
            register={register}
          />
          <div className="flex gap-2">
            <FilterActionsDropdown
              bookmarksCount={count}
              onBookmarksClick={() => toggleFiltersManagerDrawer({ store, filters, onChange })}
              onLayoutClick={() => toggleSortColumnsDrawer({ store, columns, defaultColumns })}
            />
          </div>
          <FiltersClearButton label={tFilters('clear')} onClick={onResetActiveFilter} />
        </>
      )}
    </FiltersProvider>
  );
};
